import { QUERY_KEYS } from "@/libraries/constant";
import type {
	GetCaseSyncParamsSchema,
	GetMemberSyncChatParamsSchema,
	SyncGroupParamsSchema,
	SyncMessageParamsSchema,
} from "@/schemas";
import type {
	CaseSyncResponse,
	GetSyncGroupResponse,
	MembersSyncChatResponse,
	ResError,
} from "@/types";
import { useMutation } from "@tanstack/react-query";

function useSyncMutation() {
	const memberSyncChat = useMutation<
		MembersSyncChatResponse,
		ResError,
		GetMemberSyncChatParamsSchema
	>({
		mutationKey: [QUERY_KEYS.MUTATE_MEMBER_SYNC_CHAT],
	});

	const groupSync = useMutation<
		GetSyncGroupResponse,
		ResError,
		SyncGroupParamsSchema
	>({
		mutationKey: [QUERY_KEYS.MUTATE_GROUP_SYNC],
	});

	const caseSync = useMutation<
		CaseSyncResponse,
		ResError,
		GetCaseSyncParamsSchema
	>({
		mutationKey: [QUERY_KEYS.MUTATE_CASE_SYNC],
	});

	const inboxMessagesSync = useMutation<any, ResError, SyncMessageParamsSchema>(
		{
			mutationKey: [QUERY_KEYS.MUTATE_SYNC_INBOX_MESSAGES],
		},
	);

	return { memberSyncChat, groupSync, caseSync, inboxMessagesSync };
}

export default useSyncMutation;
